const addTrailingSlash = (url) => {
  return url?.replace(/\/?$/, "/");
};
export {
  addTrailingSlash
};
//# sourceMappingURL=trailingSlash.js.map
